import { useTranslation } from 'react-i18next';
import RepaymentExampleIllustration from '../../../../assets/svgs/credit-card/repayment-example-illustration.svg';
import { BankingModalPartial } from '../../../ui/modal/BankingModalPartial';
import styles from './PortionOfSalesContent.module.css';

export interface LearnMoreModalProps {
  readonly active: boolean;
  readonly percentage?: number;
  readonly onClose: () => void;
}

export const LearnMoreModal = ({
  active,
  percentage,
  onClose,
}: LearnMoreModalProps) => {
  const { t } = useTranslation();

  const subtitle = percentage
    ? t('bankingShared.creditCard.portionOfSales.learnMore.subtitle', {
      selectedPercentage: `${percentage}%`,
    })
    : t('bankingShared.creditCard.portionOfSales.learnMore.subtitleNoPercentage');

  const content = (
    <>
      <p className="paragraph-30">
        {subtitle}
      </p>
      <p className="heading-20">
        {t('bankingShared.creditCard.portionOfSales.learnMore.example')}
      </p>
      <div className={styles.illustration}>
        <img src={RepaymentExampleIllustration} alt={t('bankingShared.creditCard.portionOfSales.learnMore.illustrationAlt')} />
      </div>
    </>
  );

  return (
    <BankingModalPartial
      active={active}
      title={t('bankingShared.creditCard.portionOfSales.learnMore.title')}
      content={content}
      onModalClose={onClose}
    />
  );
};
